import * as Schema from "effect/Schema";
import { Identifier, RevisionConflict, ValidationError } from "@linempo/kernel";
export class AssetError extends Schema.TaggedError()("AssetError", {
    assetId: Identifier, message: Schema.String,
}) {
}
export class StorageError extends Schema.TaggedError()("StorageError", {
    operation: Schema.Literals(["read", "write", "delete", "quota", "cleanup"]), message: Schema.String,
}) {
}
export class EngineError extends Schema.TaggedError()("EngineError", {
    reason: Schema.Literals(["invalid-input", "iteration-limit", "wasm-unavailable", "planning"]), message: Schema.String,
}) {
}
export class CodecError extends Schema.TaggedError()("CodecError", {
    reason: Schema.Literals(["unsupported", "encode", "mux", "finalize"]), message: Schema.String,
}) {
}
export class WorkerError extends Schema.TaggedError()("WorkerError", {
    reason: Schema.Literals(["unavailable", "timeout", "protocol", "busy"]), message: Schema.String,
}) {
}
export class Cancelled extends Schema.TaggedError()("Cancelled", { jobId: Identifier }) {
}
export const RenderError = Schema.Union([ValidationError, RevisionConflict, AssetError, StorageError, EngineError, CodecError, WorkerError, Cancelled]);
